import { render, staticRenderFns } from "./editTicketTemplate.vue?vue&type=template&id=1ebb1994&scoped=true"
import script from "./editTicketTemplate.vue?vue&type=script&lang=js"
export * from "./editTicketTemplate.vue?vue&type=script&lang=js"
import style0 from "./editTicketTemplate.vue?vue&type=style&index=0&id=1ebb1994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb1994",
  null
  
)

export default component.exports